import { useTranslation } from 'react-i18next'
import { updateCharacter } from '../../../api/character'

import { Button } from '@/components/ui/button'

import Timestamp from 'app/frontend/base/components/Timestamp'
import TeamCard from 'app/frontend/base/components/TeamCard'
import { useRefreshCharacterDetails } from 'app/frontend/base/helpers'

interface Props {
  character?: wowaudit.Character
  refetch: () => void
}

const TrackingSummary = ({ character, refetch }: Props) => {
  const { t } = useTranslation()

  const { refreshing, refreshData } = useRefreshCharacterDetails(character, {
    retriever: updateCharacter,
    id: character?.id,
    successKey: 'dashboard.character.character-update-success',
    callback: refetch,
  })

  return (
    <div className='min-h-[10rem]'>
      <p>
        {character?.teamReferences?.length
          ? t('dashboard.character.tracked-in-teams', {
              count: character?.teamReferences?.length,
            })
          : t('dashboard.character.not-tracked-in-teams')}
      </p>
      {(character?.teamReferences || []).map((team) => (
        <TeamCard key={team.id} team={team} />
      ))}

      <div className='mt-3 mb-1 pb-1 block border-b border-accent font-bold'>
        {t('shared.last-updated')}
      </div>

      {character?.details && !character?.refreshedAt ? (
        <p className='italic opacity-70'>
          {t('dashboard.character.never-refreshed')}
        </p>
      ) : null}

      <div className='flex justify-between items-center'>
        <Timestamp time={character?.refreshedAt} colorNever={true} />

        <Button
          variant='outline'
          size='sm'
          loading={refreshing}
          spinner='blizzard'
          disabled={!character?.id}
          onClick={() => refreshData()}
        >
          {t('shared.update-now')}
        </Button>
      </div>
    </div>
  )
}

export default TrackingSummary
